/* Outback Maasai story & journal pages: scroll reveal, photo lightbox,
   screens-off checklist. Vanilla, no dependencies. Loaded (deferred) by the
   om-* story sections; the guard below makes repeat tags harmless. */
(function () {
  'use strict';
  if (window.__omStory) return;
  window.__omStory = true;

  var doc = document;
  var root = doc.documentElement;
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Scroll reveal ---------- */
  var io = null;
  function showAll(scope) {
    (scope || doc).querySelectorAll('[data-om-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }
  function initReveal(scope) {
    var els = (scope || doc).querySelectorAll('[data-om-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce.matches || designMode || !('IntersectionObserver' in window)) { showAll(scope); return; }
    var vh = window.innerHeight || root.clientHeight;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    }
    els.forEach(function (el) {
      // Anything already on screen shows straight away (no flash of hidden content).
      if (el.getBoundingClientRect().top < vh * 0.95) el.classList.add('is-in');
      else io.observe(el);
    });
  }

  /* ---------- Lightbox ---------- */
  var lb, lbImg, lbCap, lbCount, items = [], index = 0, opener = null;
  function buildLightbox() {
    if (lb) return lb;
    lb = doc.createElement('dialog');
    lb.className = 'om-lb';
    lb.setAttribute('aria-label', 'Photo viewer');
    lb.innerHTML =
      '<div class="om-lb__stage">' +
      '<figure class="om-lb__fig"><img class="om-lb__img" alt=""><figcaption class="om-lb__cap"></figcaption></figure>' +
      '</div>' +
      '<p class="om-lb__count" aria-live="polite"></p>' +
      '<button type="button" class="om-lb__btn om-lb__prev" aria-label="Previous photo"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="om-lb__btn om-lb__next" aria-label="Next photo"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<button type="button" class="om-lb__close" aria-label="Close photo viewer"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 5l14 14M19 5L5 19"/></svg></button>';
    doc.body.appendChild(lb);
    lbImg = lb.querySelector('.om-lb__img');
    lbCap = lb.querySelector('.om-lb__cap');
    lbCount = lb.querySelector('.om-lb__count');
    lb.querySelector('.om-lb__prev').addEventListener('click', function () { go(-1); });
    lb.querySelector('.om-lb__next').addEventListener('click', function () { go(1); });
    lb.querySelector('.om-lb__close').addEventListener('click', close);
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('om-lb__stage')) close(); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    lb.addEventListener('close', function () {
      root.classList.remove('om-lb-open');
      if (opener && opener.focus) opener.focus();
    });
    // Swipe
    var x0 = null, y0 = null;
    lb.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; });
    lb.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
    });
    return lb;
  }
  function render() {
    var a = items[index];
    if (!a) return;
    var img = a.querySelector('img');
    lbImg.src = a.getAttribute('href');
    lbImg.alt = img ? img.getAttribute('alt') || '' : '';
    var cap = a.getAttribute('data-caption') || '';
    lbCap.textContent = cap;
    lbCap.hidden = !cap;
    lbCount.textContent = (index + 1) + ' / ' + items.length;
    lb.classList.toggle('om-lb--single', items.length < 2);
    // Warm the neighbours
    [index + 1, index - 1].forEach(function (i) {
      var n = items[(i + items.length) % items.length];
      if (n && n !== a) { var pre = new Image(); pre.src = n.getAttribute('href'); }
    });
  }
  function go(step) {
    if (items.length < 2) return;
    index = (index + step + items.length) % items.length;
    render();
  }
  function close() { if (lb && lb.open) lb.close(); }
  function open(link) {
    var gallery = link.closest('[data-om-gallery]');
    items = Array.prototype.slice.call((gallery || doc).querySelectorAll('a[data-om-lb]'));
    index = Math.max(0, items.indexOf(link));
    opener = link;
    buildLightbox();
    render();
    root.classList.add('om-lb-open');
    lb.showModal();
    lb.querySelector('.om-lb__close').focus();
  }
  doc.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[data-om-lb]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    if (typeof HTMLDialogElement !== 'function') return; // old browser: just open the photo
    e.preventDefault();
    open(link);
  });

  /* ---------- Screens-off checklist (localStorage) ---------- */
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(window.localStorage.getItem(key) || '[]');
      window.localStorage.setItem(key, JSON.stringify(val));
    } catch (err) { return []; }
  }
  function initChecklists(scope) {
    (scope || doc).querySelectorAll('[data-om-checklist]').forEach(function (box) {
      if (box.dataset.omReady) return;
      box.dataset.omReady = '1';
      var key = 'om-check:' + box.getAttribute('data-om-checklist');
      var inputs = Array.prototype.slice.call(box.querySelectorAll('input[data-om-check]'));
      var progress = box.querySelector('[data-om-progress]');
      var bar = box.querySelector('[data-om-bar]');
      var done = box.querySelector('[data-om-done]');
      var reset = box.querySelector('[data-om-reset]');
      var saved = store(key) || [];
      inputs.forEach(function (i) { i.checked = saved.indexOf(i.getAttribute('data-om-check')) > -1; });
      function update(save) {
        var ticked = inputs.filter(function (i) { return i.checked; });
        var n = ticked.length, total = inputs.length;
        if (progress) progress.textContent = n === total ? 'All ' + total + ' ticked' : n + ' of ' + total + ' ticked';
        if (bar) bar.style.width = (total ? Math.round(n / total * 100) : 0) + '%';
        if (done) done.hidden = n !== total;
        box.classList.toggle('is-done', n === total);
        if (reset) reset.hidden = n === 0;
        if (save) store(key, ticked.map(function (i) { return i.getAttribute('data-om-check'); }));
      }
      inputs.forEach(function (i) { i.addEventListener('change', function () { update(true); }); });
      if (reset) reset.addEventListener('click', function () {
        inputs.forEach(function (i) { i.checked = false; });
        update(true);
        if (inputs[0]) inputs[0].focus();
      });
      update(false);
    });
  }

  function init(scope) { initReveal(scope); initChecklists(scope); }
  root.classList.add('om-js');
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); showAll(e.target); });
})();
